<template lang="pug">
.fixed.inset-0
  .h-full.overflow-scroll.scrolling-touch(class="lg:py-0 lg:absolute lg:inset-0")
    .min-h-full.flex.flex-col.justify-center.py-24
      .w-full
          share-image

      .mt-8.max-w-md.mx-auto(class="w-10/12")
        input(type="text" v-model="state.name"
          maxlength="8"
          pattern="\d*"
          style="ime-mode:disabled"
          @input="check_Nametype"
          oncopy="return false" onpaste="return false")
        .h-0.mt-1.-mb-1.text-xs 半角のみ。8文字まで。

        .mt-12.flex.flex-wrap
        template(v-for="(key, index) of Object.keys(state)")
          template(v-if="!key.match(/name|expire|empty/)")
            .mt-2.flex
              label.w-24 {{key}}
              input.flex-grow(type="range" min="0" max="4" v-model="state[key]")
              label.w-4.ml-4 {{state[key]}}

        .mt-8.text-center
          button.w-24.router-link(@click="save") 保存
</template>
<style lang="sass" scoped>
input[type="text"]
  @apply align-middle border rounded-sm font-bebas uppercase text-center w-full
  background-color: rgba(#000, 0.5)
  font-size: 3.5rem
  line-height: 1
  height: 1.25em
  padding: 0.35em 0.1em 0.25em
</style>
<script>
import ShareImage from "@/components/status/shareImage";
export default {
  components: {
    ShareImage
  },
  computed: {
    state() {
      return this.$store.state.magrobo;
    }
  },
  methods: {
    check_Nametype(e) {
      let value = e.target.value;
      // eslint-disable-next-line no-control-regex
      const regex = /[^\x01-\x7E]/;
      while (value.match(regex)) {
        value = value.replace(regex, "");
      }
      e.target.value = value;
    },
    save() {
      this.$store.dispatch("magrobo/setAll", this.state);
    }
  }
};
</script>
